import { render, staticRenderFns } from "./AppraisalForm.vue?vue&type=template&id=6b70aace&scoped=true"
import script from "./AppraisalForm.vue?vue&type=script&lang=js"
export * from "./AppraisalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70aace",
  null
  
)

export default component.exports